import React from "react";
import { theme } from "../../theme/colors";

export default function OpenCivicDataCard({ onOpenModal }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm xl:min-w-[320px] 2xl:min-w-[360px]">
      <h3 className="text-sm font-semibold text-slate-900">
        Call to Action: Open-Source State Laws
      </h3>

      <p className="mt-2 text-sm text-slate-700">
        We want CivixThread to feel truly local to reflect the bills, hearings, and
        decisions that affect your state and district. A lot of state legislative data is
        still buried in PDFs and hard-to-use websites, which makes civic participation
        harder than it should be.
      </p>

      <ul className="mt-2 space-y-1 text-sm text-slate-700">
        <li>• Require bills and statutes to be published in open, machine-readable formats.</li>
        <li>• Provide a public API so civic apps like CivixThread can access and share this data.</li>
        <li>• Keep legislative data free, timely, and accessible to everyone in your state.</li>
      </ul>

      <button
        type="button"
        onClick={onOpenModal}
        className="mt-3 inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-md hover:opacity-95 transition-opacity w-full"
        style={{ background: theme.gradient }}
      >
        Take action on open data
      </button>
    </section>
  );
}
